/**
 * Closing Package permission keys — mirror Backend requirePermission on closing-package routes.
 */

export const CLOSING_PACKAGE_PERMISSIONS = {
  view: 'documents.view',
  upload: 'documents.upload',
  edit: 'documents.edit',
  dispatch: 'documents.dispatch',
} as const;

export type ClosingPackagePermissionKey =
  (typeof CLOSING_PACKAGE_PERMISSIONS)[keyof typeof CLOSING_PACKAGE_PERMISSIONS];

export type ClosingPackageRoleName = 'admin' | 'accountant' | 'logist' | string;

export function resolveUserRoleName(user: unknown): string | null {
  if (!user || typeof user !== 'object') return null;
  const u = user as { role?: { name?: string }; roleName?: string };
  const name = u.role?.name || u.roleName;
  return name ? String(name).trim().toLowerCase() : null;
}

export function userHasClosingPackageRole(
  user: unknown,
  allowedRoles: ReadonlyArray<ClosingPackageRoleName>
): boolean {
  const role = resolveUserRoleName(user);
  if (!role) return false;
  if (role === 'admin') return true;
  return allowedRoles.map((r) => String(r).toLowerCase()).includes(role);
}
